<div
  class="billboard-wrapper"
  *ngIf="data; else placeholder">

  <div class="breadcrumb">
    <div class="crumbs">
      <a
        i18n
        href="/"
        [routerLink]="['/']">

          {{ environment.collectionTitle }}
      </a>
      <span class="divider">/</span>
      <span class="number">{{ data.id }}</span>
      
    </div>

    <div class="save-pfp">
      <button i18n (click)="openPFPModal()">Save PFP</button>
      <button i18n (click)="downloadCard()" class="download">Download Card</button>
      
      <button #shareButton i18n (click)="share(shareButton)" class="filled">Share Floor Data</button>
    </div>
  </div>

  <div
    class="image-wrapper"
    [class.wrapped]="data?.wrapped"
    [class.c721wrapped]="data?.c721wrapped"
    [class.tokenworks]="data?.owner?.id?.toLowerCase() === TOKENWORKS_ADDRESS.toLowerCase()"
    [class.punkauction]="data?.owner?.id?.toLowerCase() === PUNKAUCTION_ADDRESS.toLowerCase()"
    [style.background-color]="selectedBackgroundColor"
    [style.boxShadow]="'inset 0 0 0 1.3rem' + selectedBorderColor">

    <!-- Marketplace icon in top-left corner -->
    <div class="marketplace-icon" *ngIf="data?.owner?.id?.toLowerCase() === TOKENWORKS_ADDRESS.toLowerCase() || data?.owner?.id?.toLowerCase() === PUNKAUCTION_ADDRESS.toLowerCase()">
      <app-marketplace-icons 
        [type]="data?.owner?.id?.toLowerCase() === TOKENWORKS_ADDRESS.toLowerCase() ? 'tokenworks' : 'punkauction'"
        size="3rem"
        contextClass="billboard">
      </app-marketplace-icons>
    </div>

    <input
      type="color"
      id="background-color-picker"
      [formControl]="backgroundColorPicker"
      tippy
      [attr.data-tippy-content]="'Background'"
      [attr.data-tippy-position]="'bottom'"
    />

    <input
      type="color"
      id="border-color-picker"
      [formControl]="borderColorPicker"
      tippy
      [attr.data-tippy-content]="'Border'"
      [attr.data-tippy-position]="'bottom'"
    />

    <img
      #tokenImage
      [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (data.id | tokenIdParse) + '.svg'"
      [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"      
      width="312"
      height="312"
      alt="{{ environment.tokenName }} #{{ data.id }}" />
  </div>
</div>

<ng-template #placeholder>
  <div class="billboard-wrapper">

    <div class="breadcrumb">
      <div class="crumbs">
        <a i18n>Loading</a>
        <span class="divider">/</span>
        <span class="number">0000</span>
      </div>

      <div class="save-pfp">
        <button i18n>Save PFP</button>
        <button i18n class="download">Download Card</button>
        <button i18n class="filled">Share Floor Data</button>
      </div>
    </div>

    <div class="image-wrapper"
      [style.background-color]="selectedBackgroundColor"
      [style.boxShadow]="'inset 0 0 0 1.3rem' + selectedBorderColor">

      <img
        #tokenImage
        [src]="'assets/loadingpunk.png'"
        width="312"
        height="312" />
    </div>
  </div>
</ng-template>

<!-- SAVE PFP -->
<div
  class="modal-overlay"
  [class.active]="pfpModalOpen">

  <div
    class="modal pfp-modal">

    <div class="punk-info">
      <h2 i18n>{{ environment.tokenName }} #{{ data?.id }}</h2>
      <canvas
        #pfp
        id="pfp"
        width="480"
        height="480">
      </canvas>
    </div>

    <div class="pfp-options">
      <div class="shape-border">

        <div class="shape-select">
          <input type="radio" id="square" name="shape" value="square" [formControl]="shapeCheck">
          <label i18n for="square">Square</label>
        </div>

        <div class="shape-select">
          <input type="radio" id="round" name="shape" value="round" [formControl]="shapeCheck">
          <label i18n for="round">Round</label>
        </div>

        <div class="shape-select">
          <input type="radio" id="hexagon" name="shape" value="hex" [formControl]="shapeCheck">
          <label i18n for="hexagon">Hexagon</label>
        </div>

        <div class="shape-select">
          <input type="radio" id="transparent" name="shape" value="trans" [formControl]="shapeCheck">
          <label i18n for="transparent">Transparent</label>
        </div>

        <!-- <div class="shape-select">
          <input type="radio" id="graphic" name="shape" value="graphic" [formControl]="shapeCheck">
          <label i18n for="graphic">Graphic</label>
        </div> -->
      </div>

      <div class="toggle-wrapper">

        <div
          class="border-toggle"
          (click)="changeBorder()">

          <div class="label">Border</div>

          <div
            class="toggle"
            [class.on]="border">
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button i18n class="cancel" (click)="pfpModalOpen = false">Cancel</button>
      <button i18n class="download" (click)="downloadCanvas()">Download</button>
    </div>
  </div>
</div>